export function Cache({ TTL }) {
  const cache = new Map();

  return {
    forKey,
    get,
    set,
  };

  function forKey(key) {
    return {
      get() {
        return get(key);
      },
      set(content) {
        set(key, content);
      },
    };
  }

  function get(key) {
    const { expiredAt, content } = cache.get(key) || {};
    return expiredAt > Date.now() ? content : null;
  }

  function set(key, content) {
    cache.set(key, {
      expiredAt: Date.now() + TTL,
      content,
    });
  }
}
